import { getTracker } from "@/shared/tracking/analytics-helpers";
import { browserAgent } from "@/shared/telemetry/newrelic";

import type { HandshakeMetadata } from "./lib/collect-metadata";

export const CHECKOUT_HANDSHAKE_EVENT = "CHECKOUT_HANDSHAKE_COMPLETED";

/**
 * Emits the handshake event to Kafka (via the existing tracker → /api/v1/events)
 * and to New Relic. IP is attached server-side. Best-effort: never blocks or
 * throws — a failed beacon must not strand the customer.
 */
export function emitCheckoutHandshake(
  checkoutId: string,
  metadata: HandshakeMetadata,
): void {
  try {
    getTracker()?.track({
      eventType: CHECKOUT_HANDSHAKE_EVENT,
      merchantId: "",
      checkoutId,
      orderId: metadata.queryParams.orderId ?? "",
      customerId: "",
      countryCode: "",
      currencyCode: "",
      eventData: {
        userAgent: metadata.userAgent,
        locale: metadata.locale,
        referrer: metadata.referrer,
        queryParams: metadata.queryParams,
        timestamp: metadata.timestamp,
      },
    });
  } catch {
    // swallow — tracking must not break the flow
  }

  try {
    browserAgent.addPageAction(CHECKOUT_HANDSHAKE_EVENT, {
      checkout_id: checkoutId,
      order_id: metadata.queryParams.orderId ?? "",
      locale: metadata.locale,
      user_agent: metadata.userAgent,
      referrer: metadata.referrer,
    });
  } catch {
    // swallow — NR must not break the flow
  }
}
